import { Files } from '../../lib/constants/files'
import { Tefl } from '../../lib/types/models/tefl/tefl'
import { TeflInput } from '../../lib/types/models/tefl/tefl-input'
import { UpdateInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function updateTefl(olId: number, data: UpdateInput<TeflInput>) {
  const { id, ...rest } = data

  if (rest.documents)
    for (let i = 0; i < rest.documents.length; i++) {
      const newFile = await uploadFile(Files.TEFL_DOCUMENT, rest.documents[i])
      if (newFile) rest.documents[i] = { ...newFile }
    }

  if (rest.diplomas)
    for (let i = 0; i < rest.diplomas.length; i++) {
      const newFile = await uploadFile(Files.TEFL_DIPLOMA, rest.diplomas[i].file)
      if (newFile) rest.diplomas[i].file = { ...newFile }
    }

  return restApiClient
    .url(constructApiUrl(API.tefl.update.url, { id, olId }))
    .patch<Tefl, Partial<TeflInput>>(rest)
}
